// extracted by mini-css-extract-plugin
export default {"title":"Financial_title_acPV5","salaryInput":"Financial_salaryInput_QlwyN"};